import {createReducer} from '@reduxjs/toolkit'

import {typePagination} from 'model/system/constants'
import {

    dCashDesksClearFiltersAC,
    dCashDesksSetDataAC, dCashDesksSetDetailItemAC, dCashDesksSetFiltersAC, dCashDesksSetItemsForPageAC,
    dCashDesksSetPageNumberAC,
    dCashDesksSetPaginationAC
} from 'model/dashboardCashDesks/dCashDesksActionCreators';
import {logoutAC, resetReducers} from 'model/system/systemActionCreators';


// Type
export type IdCashDesksStateDataItem = {
    checked?: boolean,
    dateCreated: string,
    dateEdited: string,
    fiscalCardId: string,
    id: string,
    posHardwareModel: string,
    posHardwareSerialNumber: string,
    posNumber: number,
    store?: {
        address: string,
        deleted: boolean,
        description: string,
        email: string,
        id: string,
        industry?: {
            id: string,
            name: string
        },
        manager: string,
        managerPhoneNumber: string,
        name: string,
        phoneNumber: string
    },
    blocked: boolean
}

export type IdCashDesksState =  {
    pagination: typePagination,
    data: IdCashDesksStateDataItem[],
    detailItem: IdCashDesksStateDataItem | undefined,
    filters: typeCashDesksFilters
}

export type typeCashDesksFilters = {
    fiscalCardId?: string | null,
    storeName?: string | null,
    posHardwareModel?: string | null,
    posHardwareSerialNumber?: string | null,
    deleted?: boolean | null,
}

// Clean filter object
export const cleanFilterObject: typeCashDesksFilters = {
    storeName:  null,
    posHardwareModel: null,
    posHardwareSerialNumber:  null,

    deleted: false
}


// Init state
export const initialState: IdCashDesksState = {
    pagination: {
        pageNumber: 0,
        itemsPerPage: 14,
    },
    data: [],
    detailItem: undefined,
    filters: cleanFilterObject
}


// Reducer
export const DCashDesksReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set data
        .addCase(dCashDesksSetDataAC, (state, action) => {
            state.data = action.payload.dataList
        })

        // Reducer of set pagination
        .addCase(dCashDesksSetPaginationAC, (state, action) => {
            state.pagination = {...state.pagination, ...action.payload.pagination}
        })

        // Reducer of set items for page pagination
        .addCase(dCashDesksSetItemsForPageAC, (state, action) => {
            state.pagination = { ...state.pagination,pageNumber:0, itemsPerPage: action.payload.itemsForPage }
        })

        // Reducer of set pageNumber pagination
        .addCase(dCashDesksSetPageNumberAC, (state, action) => {
            state.pagination.pageNumber = action.payload.pageNumber
        })

        // Reducer of set detail item
        .addCase(dCashDesksSetDetailItemAC, (state, action) => {
            state.detailItem = state.data.find((item) => item.id === action.payload)
        })

        // Reducer of clear filtersForm
        .addCase(dCashDesksClearFiltersAC, (state) => {
            state.filters = cleanFilterObject
        })

        // Reducer of set filters
        .addCase(dCashDesksSetFiltersAC, (state, action) => {
            state.filters = {...state.filters, ...action.payload}
            state.pagination.pageNumber = 0
        })
        // Reducer of clear state
        .addCase(logoutAC, ( state ) => {
            state.data = initialState.data
            state.detailItem=initialState.detailItem
            state.filters = initialState.filters
            state.pagination = initialState.pagination
        })

        .addCase(resetReducers, (state, action) => {
            if (action.payload !== "cashier-desk-management") {
                state.data = initialState.data
                state.detailItem=initialState.detailItem
                state.filters = initialState.filters
                state.pagination = initialState.pagination
            }
        });
})
